/* eslint-disable */
import React from 'react';
import {GroundOverlay} from '@react-google-maps/api';

interface IOverlayImageProps {
  url: string;
  polygonPaths: google.maps.LatLngLiteral[];
}

const OverlayImage = (props: IOverlayImageProps) => {
  console.log('props', props);
  const latitudes = props.polygonPaths.map((coord) => coord.lat);
  const longitudes = props.polygonPaths.map((coord) => coord.lng);

  const north = Math.max(...latitudes);
  const south = Math.min(...latitudes);
  const east = Math.max(...longitudes);
  const west = Math.min(...longitudes);

  const bounds: google.maps.LatLngBoundsLiteral = {
    north,
    south,
    east,
    west,
  };

  return <GroundOverlay url={props.url} bounds={bounds} />;
};

export default OverlayImage;
